// Mock data for Twe V3.0 website

export const recipes = [
  // Browser Category (5)
  {
    id: 1,
    title: "Open URL",
    description: "Navigate to any website using voice commands",
    category: "Browser",
    complexity: "Beginner",
    commands: ["Open github.com", "Navigate to youtube.com"],
    example: "Twe, open github.com",
    icon: "globe",
    v3: true
  },
  {
    id: 2,
    title: "Search Online",
    description: "Perform web searches instantly",
    category: "Browser",
    complexity: "Beginner",
    commands: ["Search for React hooks", "Google AI automation tools"],
    example: "Twe, search for Python tutorials",
    icon: "search",
    v3: true
  },
  {
    id: 3,
    title: "New Tab",
    description: "Open new browser tabs with voice",
    category: "Browser",
    complexity: "Beginner",
    commands: ["Open new tab", "Create tab"],
    example: "Twe, open new tab",
    icon: "plus",
    v3: true
  },
  {
    id: 4,
    title: "Close Tab",
    description: "Close current or specific browser tabs",
    category: "Browser",
    complexity: "Beginner",
    commands: ["Close tab", "Close current tab"],
    example: "Twe, close tab",
    icon: "x",
    v3: true
  },
  {
    id: 5,
    title: "Refresh Page",
    description: "Reload the current webpage",
    category: "Browser",
    complexity: "Beginner",
    commands: ["Refresh page", "Reload"],
    example: "Twe, refresh page",
    icon: "refreshCw",
    v3: true
  },

  // Files Category (4)
  {
    id: 6,
    title: "Create File",
    description: "Create new files in specified location",
    category: "Files",
    complexity: "Intermediate",
    commands: ["Create file notes.txt", "Make new document"],
    example: "Twe, create file project-plan.txt",
    icon: "fileText",
    v3: true
  },
  {
    id: 7,
    title: "Delete File",
    description: "Remove files from your system",
    category: "Files",
    complexity: "Intermediate",
    commands: ["Delete file temp.txt", "Remove old-file.doc"],
    example: "Twe, delete file temp.txt",
    icon: "trash2",
    v3: true
  },
  {
    id: 8,
    title: "Move File",
    description: "Move files between folders",
    category: "Files",
    complexity: "Intermediate",
    commands: ["Move file to Downloads", "Transfer to Documents"],
    example: "Twe, move file to Documents",
    icon: "move",
    v3: true
  },
  {
    id: 9,
    title: "Rename File",
    description: "Rename existing files with voice",
    category: "Files",
    complexity: "Intermediate",
    commands: ["Rename file to report.pdf", "Change name to final-draft"],
    example: "Twe, rename file to final-report.pdf",
    icon: "edit",
    v3: true
  },

  // Apps Category (3)
  {
    id: 10,
    title: "Open Application",
    description: "Launch any installed application",
    category: "Apps",
    complexity: "Beginner",
    commands: ["Open VS Code", "Launch Spotify", "Start Discord"],
    example: "Twe, open VS Code",
    icon: "grid",
    v3: true
  },
  {
    id: 11,
    title: "Close Application",
    description: "Quit running applications",
    category: "Apps",
    complexity: "Beginner",
    commands: ["Close Chrome", "Quit Spotify"],
    example: "Twe, close Chrome",
    icon: "xCircle",
    v3: true
  },
  {
    id: 12,
    title: "Dev Start",
    description: "Open VS Code, Spotify, and dev tools instantly",
    category: "Apps",
    complexity: "Advanced",
    commands: ["Dev start", "Launch dev environment"],
    example: "Twe, dev start",
    icon: "code",
    v3: true,
    saves: "5 mins/session"
  },

  // System Category (7)
  {
    id: 13,
    title: "Take Screenshot",
    description: "Capture your screen instantly",
    category: "System",
    complexity: "Beginner",
    commands: ["Take screenshot", "Capture screen"],
    example: "Twe, take screenshot",
    icon: "camera",
    v3: true
  },
  {
    id: 14,
    title: "Set Volume",
    description: "Adjust system volume with voice",
    category: "System",
    complexity: "Beginner",
    commands: ["Set volume to 50", "Volume 75"],
    example: "Twe, set volume to 40",
    icon: "volume2",
    v3: true
  },
  {
    id: 15,
    title: "Increase Volume",
    description: "Raise system volume incrementally",
    category: "System",
    complexity: "Beginner",
    commands: ["Increase volume by 10", "Volume up 20"],
    example: "Twe, increase volume by 10",
    icon: "volumeX",
    v3: true
  },
  {
    id: 16,
    title: "Decrease Volume",
    description: "Lower system volume incrementally",
    category: "System",
    complexity: "Beginner",
    commands: ["Decrease volume by 10", "Volume down 15"],
    example: "Twe, decrease volume by 10",
    icon: "volume1",
    v3: true
  },
  {
    id: 17,
    title: "Mute Audio",
    description: "Instantly mute system sound",
    category: "System",
    complexity: "Beginner",
    commands: ["Mute", "Silence audio"],
    example: "Twe, mute",
    icon: "volumeX",
    v3: true
  },
  {
    id: 18,
    title: "Lock Screen",
    description: "Secure your computer quickly",
    category: "System",
    complexity: "Beginner",
    commands: ["Lock screen", "Lock computer"],
    example: "Twe, lock screen",
    icon: "lock",
    v3: true
  },
  {
    id: 19,
    title: "Sleep Mode",
    description: "Put computer to sleep with voice",
    category: "System",
    complexity: "Beginner",
    commands: ["Sleep", "Put computer to sleep"],
    example: "Twe, sleep",
    icon: "moon",
    v3: true
  },

  // Windows Category (4)
  {
    id: 20,
    title: "Maximize Window",
    description: "Expand window to full screen",
    category: "Windows",
    complexity: "Beginner",
    commands: ["Maximize window", "Full screen"],
    example: "Twe, maximize window",
    icon: "maximize",
    v3: true
  },
  {
    id: 21,
    title: "Minimize Window",
    description: "Minimize active window",
    category: "Windows",
    complexity: "Beginner",
    commands: ["Minimize", "Minimize window"],
    example: "Twe, minimize window",
    icon: "minimize",
    v3: true
  },
  {
    id: 22,
    title: "Arrange Side by Side",
    description: "Position two apps side-by-side",
    category: "Windows",
    complexity: "Intermediate",
    commands: ["Arrange VS Code and Chrome side by side"],
    example: "Twe, arrange windows side by side",
    icon: "layout",
    v3: true,
    saves: "10 mins/day"
  },
  {
    id: 23,
    title: "Switch Window",
    description: "Switch between open windows",
    category: "Windows",
    complexity: "Beginner",
    commands: ["Switch window", "Next window"],
    example: "Twe, switch window",
    icon: "arrowLeftRight",
    v3: true
  },

  // Clipboard Category (3)
  {
    id: 24,
    title: "Copy Text",
    description: "Copy text to clipboard with voice",
    category: "Clipboard",
    complexity: "Beginner",
    commands: ["Copy 'Hello World'", "Copy to clipboard"],
    example: "Twe, copy 'Meeting at 3pm'",
    icon: "copy",
    v3: true
  },
  {
    id: 25,
    title: "Paste Clipboard",
    description: "Paste clipboard content",
    category: "Clipboard",
    complexity: "Beginner",
    commands: ["Paste", "Paste clipboard"],
    example: "Twe, paste",
    icon: "clipboard",
    v3: true
  },
  {
    id: 26,
    title: "Clear Clipboard",
    description: "Empty clipboard memory",
    category: "Clipboard",
    complexity: "Beginner",
    commands: ["Clear clipboard", "Empty clipboard"],
    example: "Twe, clear clipboard",
    icon: "clipboardX",
    v3: true
  },

  // Spotify Category (8)
  {
    id: 27,
    title: "Spotify Play",
    description: "Play music on Spotify",
    category: "Spotify",
    complexity: "Beginner",
    commands: ["Play my playlist", "Play Shape of You"],
    example: "Twe, play my workout playlist",
    icon: "music",
    v3: true
  },
  {
    id: 28,
    title: "Spotify Pause",
    description: "Pause Spotify playback",
    category: "Spotify",
    complexity: "Beginner",
    commands: ["Pause", "Pause Spotify"],
    example: "Twe, pause",
    icon: "pause",
    v3: true
  },
  {
    id: 29,
    title: "Spotify Next",
    description: "Skip to next track",
    category: "Spotify",
    complexity: "Beginner",
    commands: ["Next song", "Skip track"],
    example: "Twe, next song",
    icon: "skipForward",
    v3: true
  },
  {
    id: 30,
    title: "Spotify Previous",
    description: "Go back to previous track",
    category: "Spotify",
    complexity: "Beginner",
    commands: ["Previous song", "Last track"],
    example: "Twe, previous song",
    icon: "skipBack",
    v3: true
  },
  {
    id: 31,
    title: "Spotify Search",
    description: "Search for songs, artists, or albums",
    category: "Spotify",
    complexity: "Intermediate",
    commands: ["Search for artist Drake", "Find song Blinding Lights"],
    example: "Twe, search for artist Taylor Swift",
    icon: "search",
    v3: true
  },
  {
    id: 32,
    title: "Spotify Volume",
    description: "Control Spotify volume specifically",
    category: "Spotify",
    complexity: "Beginner",
    commands: ["Set Spotify volume to 60"],
    example: "Twe, set Spotify volume to 50",
    icon: "volume",
    v3: true
  },
  {
    id: 33,
    title: "Spotify Shuffle",
    description: "Toggle shuffle mode",
    category: "Spotify",
    complexity: "Beginner",
    commands: ["Shuffle on", "Enable shuffle"],
    example: "Twe, shuffle on",
    icon: "shuffle",
    v3: true
  },
  {
    id: 34,
    title: "Spotify Repeat",
    description: "Toggle repeat mode",
    category: "Spotify",
    complexity: "Beginner",
    commands: ["Repeat on", "Enable repeat"],
    example: "Twe, repeat on",
    icon: "repeat",
    v3: true
  }
];

// Keep all other exports the same
export const features = [
  {
    title: "Voice Control",
    description: "Control your browser with natural voice commands using OpenAI Realtime API",
    icon: "mic"
  },
  {
    title: "Browser Automation",
    description: "Powered by Playwright engine for reliable, fast browser control",
    icon: "globe"
  },
  {
    title: "Local Python",
    description: "All processing runs locally on your machine. Your data never leaves.",
    icon: "shield"
  },
  {
    title: "Security First",
    description: "Built with Tauri and Rust for maximum security and performance",
    icon: "lock"
  },
  {
    title: "Custom Scripts",
    description: "Write your own automation scripts in Python with our simple API",
    icon: "fileCode"
  },
  {
    title: "Cross-Browser",
    description: "Support for Chrome, Edge, and upcoming Firefox support",
    icon: "layout"
  }
];

export const roadmapItems = [
  {
    status: "Done",
    items: [
      { title: "Voice VAD (Voice Activity Detection)", description: "Real-time voice detection" },
      { title: "Chrome Support", description: "Full Chrome browser automation" },
      { title: "Windows Build", description: "Native Windows application" }
    ]
  },
  {
    status: "In Progress",
    items: [
      { title: "Firefox Support", description: "Mozilla Firefox browser support" },
      { title: "Local LLM Support (Ollama)", description: "Run AI models locally" },
      { title: "Plugin System", description: "Community plugin marketplace" }
    ]
  },
  {
    status: "Planned",
    items: [
      { title: "Mac/Linux Builds", description: "Cross-platform support" },
      { title: "Mobile Companion App", description: "Control from your phone" },
      { title: "Team Collaboration", description: "Share automations with your team" }
    ]
  }
];

export const pricingPlans = [
  {
    name: "Free",
    price: "$0",
    description: "50k tokens/day",
    features: [
      "50,000 tokens per day (~33 voice conversations)",
      "10 minutes of voice time daily",
      "Browser control (open websites, manage tabs)",
      "App launching (VS Code, Spotify, Discord, etc.)",
      "System controls (volume, screenshots, files)",
      "Window arrangement",
      "Spotify music control",
      "AI voice assistant (OpenAI gpt-4o-mini-realtime)",
      "Basic community support"
    ],
    cta: "Get Started Free",
    popular: false
  },
  {
    name: "Pro",
    price: "$19",
    period: "/month",
    description: "500k tokens/day",
    features: [
      "500,000 tokens per day (~333 conversations) - 10x Free",
      "60 minutes of voice time daily - 6x Free",
      "Everything in Free plan",
      "Custom voice options (multiple AI voices)",
      "Priority support (faster response times)",
      "3 concurrent sessions (multiple devices)",
      "300 requests per hour (5x Free rate limit)",
      "10% grace period on daily limits (550k buffer)"
    ],
    cta: "Start Pro Plan",
    popular: true
  },
  {
    name: "Ultimate",
    price: "$49",
    period: "/month",
    description: "Unlimited tokens",
    features: [
      "UNLIMITED tokens per day",
      "UNLIMITED voice time",
      "Everything in Pro plan",
      "Team sharing (multiple users)",
      "10 concurrent sessions (perfect for teams)",
      "1000 requests per hour rate limit",
      "Priority support (highest priority queue)",
      "Dedicated account manager",
      "Custom integrations (API access)",
      "Usage analytics dashboard"
    ],
    cta: "Start Ultimate Plan",
    popular: false
  }
];

export const docs = [
  {
    category: "Getting Started",
    items: [
      { title: "Installation Guide", description: "How to install Twe and bypass SmartScreen warnings", link: "/installation" },
      { title: "First Automation", description: "Create your first voice-controlled workflow" },
      { title: "Configuration", description: "Set up your preferences and API keys" }
    ]
  },
  {
    category: "API Reference",
    items: [
      { title: "Voice Commands API", description: "Control Twe via Python scripts" },
      { title: "Browser Control", description: "Playwright integration guide" },
      { title: "Plugin Development", description: "Build custom plugins" }
    ]
  },
  {
    category: "Advanced",
    items: [
      { title: "Security Architecture", description: "Understanding Twe's security model" },
      { title: "Performance Tuning", description: "Optimize your automations" },
      { title: "Troubleshooting", description: "Common issues and solutions" }
    ]
  }
];

export const trustFeatures = [
  {
    title: "The Kill Switch",
    description: "Hardware-level microphone mute. When you press the button, the mic is physically disconnected. No software can override it.",
    icon: "power"
  },
  {
    title: "Local Processing",
    description: "All Python scripts run locally on your machine. Your voice data is processed through OpenAI's API, but your browsing data never leaves your computer.",
    icon: "cpu"
  },
  {
    title: "Open Source Core",
    description: "Built with Tauri (Rust) and open-source components. You can inspect the code yourself on GitHub.",
    icon: "github"
  },
  {
    title: "No Data Collection",
    description: "We don't track your usage, collect your browsing history, or sell your data. Ever.",
    icon: "eyeOff"
  }
];